
/**
 * @param {LibraryFolder[]} libraryFolders
 * @return {LibraryFolder[]}
 */
import { ActivityTypeLookup } from "./library-types"

export function sortLibraryFolders(libraryFolders = []) {
  return [...libraryFolders].sort((a, b) => {
    const folderCompare = (a.folder_name || "").localeCompare(b.folder_name || "")

    if (folderCompare !== 0) return folderCompare

    return (a.pk_folder_key || "").localeCompare(b.pk_folder_key || "")
  })
}


/**
 * @param {MyLibrary[]} myLibraries
 * @return {MyLibrary[]}
 */
export function sortLibraryBySubjectName(myLibraries = []) {



  return [...myLibraries]
    .sort((a, b) => (a.subject_name || '').localeCompare(b.subject_name || ''))
}

/**
 * @typedef {Object} ActivityGroup
 * @property {string} activity_type_name
 * @property {TutorLibraryItem[]} items
 */

/**
 * @typedef {Object} FolderGroup
 * @property {string} folder_name
 * @property {Object.<string, ActivityGroup>} items
 * @property {string[]} sortedKeys
 */

/**
 * @typedef {Object} GroupedItemsByFolderActivityType
 * @property {Object.<string, FolderGroup>} items
 * @property {string[]} sortedKeys
 */

/**
 * @param {TutorLibraryItem[]} libraryItems
 * @return {GroupedItemsByFolderActivityType}
 */
export function groupItemsByFolderActivityType(libraryItems){
  const _groupedItems = libraryItems.reduce((acc, item) => {
    const { pk_folder_key, folder_name, activity_type } = item

    const _pk_folder_key = pk_folder_key || "no_folder"
    const _folder_name = folder_name || "Uncategorized"

    if (!acc.items) {
      acc.items = {}
    }

    // Level 1: folder
    if (!acc.items[_pk_folder_key]) {
      acc.items[_pk_folder_key] = {
        folder_name: _folder_name,
        items: {},
      }
    }

    const folder = acc.items[_pk_folder_key]

    // Level 2: activity type
    if (!folder.items[activity_type]) {
      folder.items[activity_type] = {
        activity_type_name: ActivityTypeLookup[activity_type],
        items: [],
      }
    }
    folder.items[activity_type].items.push(item)

    return acc
  }, {})

  const sortedFolderKeys = Object.keys(_groupedItems.items).sort((a, b) =>
    _groupedItems.items[a].folder_name.localeCompare(_groupedItems.items[b].folder_name)
  )

  sortedFolderKeys.forEach(folderKey => {
    const folder = _groupedItems.items[folderKey]

    const sortedActivityKeys = Object.keys(folder.items).sort((a, b) =>
      folder.items[a].activity_type_name.localeCompare(folder.items[b].activity_type_name)
    )
    folder.sortedKeys = sortedActivityKeys;

    Object.values(folder.items).forEach(activity => {
      activity.items.sort((a, b) => (a.name || "").localeCompare(b.name || ""))
    })
  })

  _groupedItems.sortedKeys = sortedFolderKeys;

  return _groupedItems;
}

/**
 * @param {TutorLibraryItem[]} libraryItems
 * @param {string} searchTerm
 * @returns {Object.<string, Object.<string, TutorLibraryItem[]>>}
 */
export const groupByFolderThenType = (libraryItems, searchTerm) => {
  const grouped = {};

  libraryItems
    .filter(
      (libItem) =>
        (libItem.name &&
          libItem.name.toLowerCase().includes(searchTerm)) ||
        (libItem.source &&
          libItem.source.toLowerCase().includes(searchTerm)) ||
        (libItem.description &&
          libItem.description.toLowerCase().includes(searchTerm)) ||
        (libItem.folder_name &&
          libItem.folder_name.toLowerCase().includes(searchTerm)) ||
        (libItem.coins &&
          String(libItem.coins).toLowerCase().includes(searchTerm))
    )
    .forEach((item) => {
      const folder = item.folder_name || "Uncategorized";

      const type =ActivityTypeLookup[item.activity_type] || "Other";

      if (!grouped[folder]) {
        grouped[folder] = {};
      }

      if (!grouped[folder][type]) {
        grouped[folder][type] = [];
      }

      grouped[folder][type].push(item);
    });

  const sortedGrouped= Object.keys(grouped)
    .sort()
    .reduce((folderAcc, folder) => {
      folderAcc[folder] = Object.keys(grouped[folder])
        .sort()
        .reduce((typeAcc, type) => {
          typeAcc[type] = [...grouped[folder][type]].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "", undefined, {
              sensitivity: "base",
              numeric: true,
            })
          )
          return typeAcc
        }, {})
      return folderAcc
    }, {})

  return sortedGrouped;
};

// export const createActivityTypeOptions = () => {
//
//   let options= [];
//   Object.entries(ActivityTypeLookup).forEach(([value, label]) => {
//     options.push({ label, value });
//   });
//
//   return options;
// }